import guitar from './guitar'
// import { default as ukulele } from './db/ukulele';

export default {
  guitar
  // ukulele
}
